import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { PlanInitializer, PlanProvider } from '@/entities/Plan'
import { ThemeButton } from '@/features/Theme'
import { Page } from '@/shared/components/layers/Page/Page'
import { DashboardProvider } from '../Dashboard/context/dashboard.contex'
import SalesAnalyticsPage from '../AnalyticsPage'
import AutumnUpdatePopup from '../AutumnUpdatePopup/AutumnUpdatePopup'
import MethodologyPage from '../MethodologyPage/MethodologyPage'
import SalePlan from '../_SalePlan'
import HeaderDashboard from '../HeaderDashboard'

export default function SalesWorkspace() {
  const location = useLocation()
  const analyticsOpen = location.pathname.toLowerCase().endsWith('/analytics')
  const methodologyOpen = location.pathname.toLowerCase().endsWith('/methodology')
  const detailPageOpen = analyticsOpen || methodologyOpen

  useEffect(() => {
    document.title = analyticsOpen
      ? 'OKG: Аналитика продаж'
      : methodologyOpen ? 'OKG: Как считаются показатели' : 'OKG: План продаж'
  }, [analyticsOpen, methodologyOpen])

  return <PlanProvider>
    <PlanInitializer />
    <DashboardProvider>
      <Page title={analyticsOpen ? 'OKG: Аналитика продаж' : methodologyOpen ? 'OKG: Как считаются показатели' : 'OKG: План продаж'}>
        <HeaderDashboard />
        {/* Дашборд не размонтируется: даты и загруженные планы сохраняются при возврате. */}
        <div hidden={detailPageOpen} aria-hidden={detailPageOpen}>
          <SalePlan />
        </div>
        {analyticsOpen && <SalesAnalyticsPage />}
        {methodologyOpen && <MethodologyPage />}
        <AutumnUpdatePopup />
      </Page>
    </DashboardProvider>
    <ThemeButton />
  </PlanProvider>
}
